export default __webpack_public_path__ + "static/media/wpmtest_locked.65d1b509.svg";